import { render } from "./BrandJoomBoos.vue?vue&type=template&id=a619190e"
import script from "./BrandJoomBoos.vue?vue&type=script&lang=ts"
export * from "./BrandJoomBoos.vue?vue&type=script&lang=ts"

import "./BrandJoomBoos.vue?vue&type=style&index=0&id=a619190e&lang=scss"
script.render = render

export default script